import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DialogStateService {
  private readonly _open$ = new BehaviorSubject<boolean>(false);
  private _ignoreNextOutsideClick = false;

  readonly open$ = this._open$.asObservable();

  get isOpen(): boolean {
    return this._open$.value;
  }

  setOpen(isOpen: boolean) {
    this._open$.next(isOpen);
  }

  ignoreNextOutsideClick() {
    this._ignoreNextOutsideClick = true;
  }

  consumeIgnoreNextOutsideClick(): boolean {
    if (this._ignoreNextOutsideClick) {
      this._ignoreNextOutsideClick = false;
      return true;
    }
    return false;
  }
}
